import React, { useState, useEffect } from "react";
import arrow from "../Icons/arrow.svg";
import Sidebar from "../Components/Siderbar";
import Footer from "../Components/Footer";
import { ToastContainer, toast } from 'react-toastify';
import { useParams } from 'react-router-dom';

const UpdateDeliveryAgentEarnings = () => {
  const { id: earningsId } = useParams(); 
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const epicxTenantId = localStorage.getItem('epicxTenantId');
  const AuthorizationToken = localStorage.getItem('token');
  const [formData, setFormData] = useState({
    agentId: "",
    agentName: "",
    date: "",
    totalDeliveries: "",
    totalEarnings: "",
    deductions: "",
    netEarnings: "",
    paymentStatus: "",
    comments: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/deliveryVendor/api/deliveryAgentEarnings/${epicxTenantId}/earnings/${earningsId}`,
          {
            headers: {
                Authorization: `Bearer ${AuthorizationToken}`,
              },
            }
        );
        if (response.ok) {
          const data = await response.json();
          setFormData({
            agentId: data.agentId || "",
            agentName: data.agentName || "",
            date: data.date || "",
            totalDeliveries: data.totalDeliveries || "",
            totalEarnings: data.totalEarnings || "",
            deductions: data.deductions || "",
            netEarnings: data.netEarnings || "",
            paymentStatus: data.paymentStatus || "",
            comments: data.comments || "",
          });
        } else {
          toast.error("Failed to fetch data. Please try again later.");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("An error occurred while fetching data.");
      }
    };

    fetchData();
  }, [earningsId]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleSubmit = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/deliveryVendor/api/deliveryAgentEarnings/${epicxTenantId}/earnings/${earningsId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${AuthorizationToken}`,
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.json();

      if (response.ok) {
        toast.success("Earnings record updated successfully");
        setFormData({
          agentId: "",
          agentName: "",
          date: "",
          totalDeliveries: "",
          totalEarnings: "",
          deductions: "",
          netEarnings: "",
          paymentStatus: "",
          comments: "",
        });
      } else {
        alert(`Error: ${result.message}`);
      }
    } catch (error) {
      console.error("Error updating delivery agent earnings:", error);
      alert("Failed to submit earnings record. Please try again.");
    }
  };

  const handleCancel = () => {
    setFormData({
      agentId: "",
      agentName: "",
      date: "",
      totalDeliveries: "",
      totalEarnings: "",
      deductions: "",
      netEarnings: "",
      paymentStatus: "",
      comments: "",
    });
  };

  return (
    <>
      <Sidebar />
      <div style={{ height: "92vh", overflowY: "auto", width: "100%" }}>
        <div className="container">
          <h5 style={{ padding: "20px" }}>Update Delivery Agent Earnings</h5>
          <div style={{ display: "flex", flexDirection: "column", gap: "20px", paddingBottom: "20px" }}>
            <div className="card">
              <div className="card-header bg-light d-flex justify-content-between align-items-center">
                <h5>Delivery Agent Earning Information</h5>
              </div>
              <div className="card-body" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <div className="row">
                  <div className="col">
                    <label htmlFor="agentId">Agent Id</label>
                    <input
                      type="text"
                      className="form-control bg-light"
                      id="agentId"
                      value={formData.agentId}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="agentName">Agent Name</label>
                    <input
                      type="text"
                      className="form-control bg-light"
                      id="agentName"
                      value={formData.agentName}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="date">Date</label>
                    <input
                      type="date"
                      className="form-control bg-light"
                      id="date"
                      value={formData.date}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <label htmlFor="totalDeliveries">Total Deliveries</label>
                    <input
                      type="number"
                      className="form-control bg-light"
                      id="totalDeliveries"
                      value={formData.totalDeliveries}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="totalEarnings">Total Earnings</label>
                    <input
                      type="number"
                      className="form-control bg-light"
                      id="totalEarnings"
                      value={formData.totalEarnings}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="deductions">Deductions</label>
                    <input
                      type="number"
                      className="form-control bg-light"
                      id="deductions"
                      value={formData.deductions}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <label htmlFor="netEarnings">Net Earnings</label>
                    <input
                      type="text"
                      className="form-control bg-light"
                      id="netEarnings"
                      value={formData.netEarnings}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="paymentStatus">Payment Status</label>
                    <select
                      className="form-control bg-light"
                      id="paymentStatus"
                      value={formData.paymentStatus}
                      onChange={handleChange}
                      style={{
                        backgroundImage: `url(${arrow})`,
                        backgroundPosition: "right 10px center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "16px 16px",
                        paddingRight: "30px",
                        color: "gray",
                      }}
                    >
                      <option>Select status</option>
                      <option>Paid</option>
                      <option>Pending</option>
                      <option>Overdue</option>
                    </select>
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <label htmlFor="comments">Comments</label>
                    <textarea
                      id="comments"
                      className="form-control bg-light"
                      rows="2"
                      value={formData.comments}
                      onChange={handleChange}
                      placeholder="Enter your comments here..."
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="row" style={{ backgroundColor: "#e5e5e5", padding: "10px", marginBottom: '-1.6%', marginTop: '6.5%', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div className="col text-start">
                <button className="btn" style={{ backgroundColor: 'white', color: 'black' }} onClick={handleCancel}>Cancel</button>
              </div>
              <div className="col text-end">
                <button className="btn btn-success" onClick={handleSubmit}>
                  Update Delivery Agent Earnings
                </button>
              </div>
            </div>
          </div>
        </div>
        <div>
          <Footer />
        </div>
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={true}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          style={{ zIndex: 9999 }}
        />
      </div>
    </>
  );
};

export default UpdateDeliveryAgentEarnings;
